(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drh-product-reviews"] && !Shopify.designMode) return;
  try {
    
  function createReviewText(parent, tagName, className, text) {
    if (!text) return null;

    var element = document.createElement(tagName);
    element.className = className;
    element.textContent = text;
    parent.appendChild(element);
    return element;
  }

  function createReviewCard(review) {
    var article = document.createElement('article');
    article.className = 'drh-product-reviews__card';

    var meta = document.createElement('div');
    meta.className = 'drh-product-reviews__card-meta';

    var stars = document.createElement('span');
    stars.className = 'drh-product-reviews__card-stars';
    stars.setAttribute('role', 'img');

    var rating = Number(review.rating) || 0;
    stars.setAttribute('aria-label', rating + ' von 5 Sternen');

    for (var index = 1; index <= 5; index += 1) {
      var star = document.createElement('span');
      if (index > rating) {
        star.className = 'drh-product-reviews__star-empty';
      }
      star.setAttribute('aria-hidden', 'true');
      star.textContent = '★';
      stars.appendChild(star);
    }

    meta.appendChild(stars);

    if (review.submittedAt && review.submittedDate) {
      var time = document.createElement('time');
      time.setAttribute('datetime', review.submittedAt);
      time.textContent = review.submittedDate;
      meta.appendChild(time);
    }

    article.appendChild(meta);

    createReviewText(article, 'h3', 'drh-product-reviews__card-title', review.title);
    createReviewText(article, 'p', 'drh-product-reviews__card-text', review.text);

    var source = document.createElement('p');
    source.className = 'drh-product-reviews__card-source';
    source.textContent = (review.verified ? 'Verifizierte Bewertung · ' : '') + (review.source || 'Trusted Shops');
    article.appendChild(source);

    return article;
  }

  function readDeferredReviews(section) {
    if (section.drhDeferredReviews) {
      return section.drhDeferredReviews;
    }

    var data = section.querySelector('[data-drh-reviews-data]');
    if (!data) {
      section.drhDeferredReviews = [];
      return section.drhDeferredReviews;
    }

    try {
      section.drhDeferredReviews = JSON.parse(data.textContent || '[]');
    } catch (error) {
      section.drhDeferredReviews = [];
    }

    return section.drhDeferredReviews;
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-drh-reviews-show-more]');
    if (!button) return;

    var section = button.closest('.drh-product-reviews-section');
    if (!section) return;

    var list = section.querySelector('[data-drh-reviews-list]');
    if (!list) return;

    var reviews = readDeferredReviews(section);
    var currentIndex = Number(section.getAttribute('data-drh-review-index')) || 0;
    var batchSize = Number(button.getAttribute('data-drh-reviews-batch-size')) || 5;
    var nextReviews = reviews.slice(currentIndex, currentIndex + batchSize);

    nextReviews.forEach(function(review) {
      list.appendChild(createReviewCard(review));
    });

    var nextIndex = currentIndex + nextReviews.length;
    section.setAttribute('data-drh-review-index', String(nextIndex));

    var status = section.querySelector('[data-drh-reviews-status]');
    if (status && nextReviews.length > 0) {
      status.textContent = nextReviews.length + ' weitere Bewertungen geladen.';
    }

    if (nextIndex >= reviews.length) {
      button.hidden = true;
      button.setAttribute('aria-expanded', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  function initWishlistPage() {
    const grid = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');
    const loading = document.querySelector('[data-wishlist-loading]');
    if (!grid) return;

    // Wait for WishlistManager if not initialized yet
    if (!window.wishlist) {
      document.addEventListener('wishlist:ready', initWishlistPage, { once: true });
      return;
    }

    const wl = window.wishlist;
    const items = wl.getAll();
    const removeLabel = grid.dataset.removeLabel || 'Remove';

    if (items.length === 0) {
      if (loading) loading.style.display = 'none';
      if (empty) empty.style.display = '';
      return;
    }

    const BATCH_SIZE = 4;

    async function fetchProduct(item) {
      try {
        const res = await fetch('/products/' + item.handle + '?section_id=wishlist-product-card');
        if (!res.ok) {
          wl.remove(item.id);
          return null;
        }
        const html = await res.text();
        // Check if the response contains an actual product (deleted/unpublished products render empty href)
        if (!html || html.includes('href=""') || !html.includes('/products/')) {
          wl.remove(item.id);
          return null;
        }
        return { id: item.id, html };
      } catch (e) {
        return null;
      }
    }

    async function loadBatch(batch) {
      const results = await Promise.all(batch.map(fetchProduct));
      results.forEach(function(result) {
        if (!result) return;
        var wrapper = document.createElement('div');
        wrapper.className = 'wishlist-page__grid-item';
        wrapper.setAttribute('data-wishlist-item', result.id);
        wrapper.innerHTML = result.html;

        // Add explicit remove button
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'wishlist-page__remove-btn';
        removeBtn.textContent = removeLabel;
        removeBtn.setAttribute('data-wishlist-remove', result.id);
        removeBtn.setAttribute('aria-label', removeLabel);
        wrapper.appendChild(removeBtn);

        grid.appendChild(wrapper);
      });
    }

    function removeItem(productId) {
      wl.remove(productId);
      var itemEl = grid.querySelector('[data-wishlist-item="' + productId + '"]');
      if (itemEl) {
        itemEl.classList.add('is-removing');
        itemEl.addEventListener('animationend', function() {
          itemEl.remove();
          if (grid.children.length === 0) {
            grid.style.display = 'none';
            if (empty) empty.style.display = '';
          }
        });
      }
    }

    // Delegated click handler for remove buttons
    grid.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        removeItem(removeBtn.getAttribute('data-wishlist-remove'));
      }
    });

    // Also handle removal via heart button (wishlist:remove event)
    document.addEventListener('wishlist:remove', function(e) {
      var itemEl = grid.querySelector('[data-wishlist-item="' + e.detail.id + '"]');
      if (itemEl) {
        itemEl.classList.add('is-removing');
        itemEl.addEventListener('animationend', function() {
          itemEl.remove();
          if (grid.children.length === 0) {
            grid.style.display = 'none';
            if (empty) empty.style.display = '';
          }
        });
      }
    });

    async function loadAll() {
      for (var i = 0; i < items.length; i += BATCH_SIZE) {
        var batch = items.slice(i, i + BATCH_SIZE);
        await loadBatch(batch);
      }

      if (loading) loading.style.display = 'none';

      if (grid.children.length > 0) {
        grid.style.display = '';
      } else {
        if (empty) empty.style.display = '';
      }

      // Sync heart buttons to show as filled
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: wl.count } }));
    }

    loadAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPage);
  } else {
    initWishlistPage();
  }

  } catch(e) { console.error(e); }
})();
})();
